import React, { Component } from 'react';
import TechSlider from '../ImageSlider/TechSlider';
import TechSlots from '../TechSlots/TechSlots';
import './tech-container.scss';

export default class TechContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnState: 'slider',
    };
  }

  clickHandler(prop) {
    this.setState({ btnState: prop });
  }
  render() {
    return (
      <section id="technologies" className="tech-section">
        <div className="container tech-container">
          <div className="button">
            <button
              className={`switch-btn left ${
                this.state.btnState === 'slider' ? 'active' : ''
              }`}
              onClick={() => this.clickHandler('slider')}
              style={{}}
            >
              Slider
            </button>
            <button
              className={`switch-btn right ${
                this.state.btnState === 'slots' ? 'active' : ''
              }`}
              onClick={() => this.clickHandler('slots')}
              style={{}}
            >
              Slots
            </button>
          </div>
          {this.state.btnState === 'slider' ? <TechSlider /> : null}
          {this.state.btnState === 'slots' ? <TechSlots /> : null}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tech/TechContainer.js